import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "radix-ui";

/**
 * Reusable Kubernetes Cluster information tooltip
 * Shows pre-installed tools and cluster capabilities
 */
export const KubernetesClusterInfoTooltip: React.FC = () => {
  return (
    <Tooltip.Root delayDuration={0}>
      <Tooltip.Trigger asChild>
        <InformationCircleIcon className="h-5 w-5 text-highlight cursor-help" />
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content className="w-96 z-50 animate-fade-in rounded-md bg-zinc-800 text-white text-sm shadow-md">
          <div className="text-white p-6 w-96">
            <p className="mb-2">
              At the moment, we only support single-node K8s clusters.
            </p>
            <p className="font-semibold mb-1">Pre-installed tools:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>MicroK8s</strong> - Lightweight Kubernetes distribution
                via snap
              </li>
              <li>
                <strong>GPU Operator</strong> - Enables GPU support in K8s
                (microk8s enable gpu)
              </li>
              <li>
                <strong>DNS</strong> - Cluster DNS addon
              </li>
              <li>
                <strong>Hostpath Storage</strong> - Local storage provisioner
              </li>
              <li>
                <strong>kubectl</strong> - Latest stable version with
                architecture detection
              </li>
              <li>
                <strong>Helm 3</strong> - Kubernetes package manager
              </li>
              <li>
                <strong>Kubeconfig</strong> - Automatically configured at
                ~/.kube/config
              </li>
            </ul>
          </div>
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};
